import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const teacherRepresentatives = [
  "Mrs. Rebecca James",
  "Mr. & Mrs. Abhishek Singh",
  "Mr. & Mrs. Rakesh V. J.",
  "Mrs. Seema Yadav",
  "Mrs. Shivani Jaiswal",
  "Mr. Johnson Kujur",
];

const officeBearers = [
  "Aditya Aryan",
  "Vartika Mishra",
  "Ankit Prajapati",
  "Arpita Pandey",
  "Mahfooz Ansari",
  "Sweta Kumari",
  "Praduman Yadav",
  "Navya Rai",
  "Abhineet Kr. Gupta",
  "Arpita Yadav",
  "Aman Kumar",
  "Pallavi Singh",
];

const parentRepresentatives = [
  {
    parent: "Mr. & Mrs. R. K. Rawat",
    student: "Aadish Rawat",
  },
  {
    parent: "Mr. & Mrs. Ajit Gupta",
    student: "Devrat, Vaishnavi & Pari Gupta",
  },
  {
    parent: "Mr. & Mrs. Dhanwant Singh",
    student: "Manvik Singh",
  },
  {
    parent: "Mr. & Mrs. Jai Giri",
    student: "Anshika & Pratigya Giri",
  },
  {
    parent: "Mr. & Mrs. S. Prasad",
    student: "Prince Kumar",
  },
  {
    parent: "Mrs. Poornima Srivastava",
    student: "Shivansh & Aarya Srivastava",
  },
  {
    parent: "Mr. & Mrs. M. Pandey",
    student: "Ganesh & Shivesh Pandey",
  },
];

const Parents = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header toggleSidebar={() => setOpen(true)} />
      <Sidebar isOpen={open} close={() => setOpen(false)} />

      <main className="page-wrapper">
        {/* HERO */}
        <div className="about-hero">
          <div className="about-overlay">
            <h1>PARENTS</h1>
            <p>Strong Partnership Between School & Family</p>
            <Breadcrumb />
          </div>
        </div>

        <div className="container">

          <div className="about-vision">
            <h2 className="pta-title">
              Parent Teacher Association
            </h2>
            {/* Teacher Representatives */}
            <div className="vision-card">
              <h3 className="pta-heading">Teacher</h3>

              <ul className="pta-list">
                {teacherRepresentatives.map((teacher, index) => (
                  <li key={index}>{teacher}</li>
                ))}
              </ul>
            </div>

            {/* School Office Bearers */}
            <div className="vision-card">
              <h3 className="pta-heading">School Office Bearers</h3>

              <ul className="pta-list">
                {officeBearers.map((member, index) => (
                  <li key={index}>{member}</li>
                ))}
              </ul>
            </div>

            {/* Parent Representatives */}
            <div className="vision-card">
              <h3 className="pta-heading">Parent</h3>

              <div className="parent-list">
                {parentRepresentatives.map((item, index) => (
                  <div className="parent-item" key={index}>
                    <strong>{item.parent}</strong>
                    <p>Parents of - {item.student}</p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Parents;